@if (content) {
  <div class="cms-content-wrap"
    [innerHtml]="content | replaceTokensArray: {keys: replaceTokenKeys} | safe: 'html' " runScripts>
  </div>
}
